import $ from 'jquery';
import 'slick-carousel';

const Slider = (el) => {

    const $el = $(el);
    const $slider = $el.find('.js-slider-list');
    const $prev = $el.find('.js-slider-prev');
    const $next = $el.find('.js-slider-next');

    $slider.slick({
        nextArrow: $next,
        prevArrow: $prev,
        dots: true,
        dotsClass: 'gallery__paging',
        customPaging: function (slider, i) {
            return  $('.gallery__pagination-string').text() + ' ' + (i + 1) + '/' + slider.slideCount;
        },
    });
}

export default Slider;
